import axios from 'axios';
import removeDuplicates from '@/utils/functions/removeDuplicates';
import ApiUrls from '../../consts/api-urls';

export default {
  data() {
    return {
    };
  },
  mounted() {
  },
  methods: {
    // APIs
    getPropertyData(id) {
      return axios.get(ApiUrls.getPropertyDataUrl(id))
        .then(r => r.data)
        .catch(() => false);
    },
    getExtraPropertyData(id) {
      const ret = axios.get(ApiUrls.getExtraPropertyDataUrl(id));
      return ret;
    },
    getPrefectureList(n = 0, kind = 0) {
      return axios.get(ApiUrls.getPrefectureListUrl(n, kind)).then(r => r.data);
    },
    getCityList(n = 0, cd, kind) {
      return axios.get(ApiUrls.getCityListUrl(n, cd, kind)).then(r => r.data);
    },
    getTownList(n = 0, cd, kind = 0) {
      return axios.get(ApiUrls.getTownListUrl(n, cd, kind)).then(r => r.data);
    },
    identifyTownCode(cd) {
      return axios.get(`https://open-data.iemarco.jp/api/v1/towns/${cd}`);
    },
    async getJuniorHighSchools(name, pref, city) {
      const result = await axios.get(ApiUrls.getJuniorHighSchoolsUrl(name, pref, city)).then(r => r.data);
      return removeDuplicates(result.result);
    },
    async getElementarySchools(name, pref, city) {
      const result = await axios.get(ApiUrls.getElementarySchoolsUrl(name, pref, city)).then(r => r.data);
      return removeDuplicates(result.result);
    },
    async getJuniorHighSchoolDistricts(lat, lng) {
      const result = await axios.get(ApiUrls.getJuniorHighSchoolDistrictsUrl(lat, lng)).then(r => r.data);
      return result.result;
    },
    async getElementarySchoolDistricts(lat, lng) {
      const result = await axios.get(ApiUrls.getElementarySchoolDistrictsUrl(lat, lng)).then(r => r.data);
      return result.result;
    },
    getRPList(cityid) {
      return axios.get(
        ApiUrls.getRPListUrl(cityid),
        {
          headers: { 'X-API-KEY': process.env.VUE_APP_MICROCMS_API_KEY_1 },
        })
        .then(m => m);
    },
    getAreaRPList(pref, city = 0) {
      return axios.get(
        ApiUrls.getAreaRPListUrl(pref, city),
        {
          headers: { 'X-API-KEY': process.env.VUE_APP_MICROCMS_API_KEY_1 },
        })
        .then(m => m);
    },
    getMypageInfoList(limit = 0) {
      return axios.get(
        ApiUrls.getMypageInfoListUrl(limit),
        {
          headers: { 'X-API-KEY': process.env.VUE_APP_MICROCMS_API_KEY_1 },
        })
        .then(m => m);
    },
    getSuggestList(limit = 4) {
      return axios.get(
        ApiUrls.getSuggestListUrl(limit),
        {
          headers: { 'X-API-KEY': process.env.VUE_APP_MICROCMS_API_KEY_1 },
        })
        .then(m => m);
    },
    getBlogList(cat = 0, limit = 3) {
      return axios.get(
        ApiUrls.getBlogListUrl(cat, limit),
        {
          headers: { 'X-API-KEY': process.env.VUE_APP_MICROCMS_API_KEY_1 },
        })
        .then(m => m);
    },
    getModifiableTextList() {
      return axios.get(
        ApiUrls.getModifiableTextListUrl(),
        {
          headers: { 'X-API-KEY': process.env.VUE_APP_MICROCMS_API_KEY_1 },
        })
        .then(m => m);
    },
    async getPlanePropertyList(limit, prefCode, cityCode = 0) {
      let searchUrl;
      if (process.env.VUE_APP_ENV === 'prod') {
        searchUrl = 'https://l4goeq8bil.execute-api.ap-northeast-1.amazonaws.com/develop'; // 本番環境
      } else {
        searchUrl = 'https://y7dk5n6mq3.execute-api.ap-northeast-1.amazonaws.com/stg';// 開発環境
      }
      let field;
      let code;
      if (cityCode === 0) {
        field = 'pref_code';
        code = prefCode;
      } else {
        field = 'city_code';
        code = cityCode;
      }
      const p = new Date();
      p.setDate(p.getDate() - 15); // 14日以内
      const provided = `(and+(range+field%3Dprovided_at+%7B'${p.getFullYear()}-${p.getMonth() + 1}-${p.getDate()}T00%3A00%3A00Z'%2C%7D))`;
      let q = '';
      q = `${searchUrl}?q=(and+(and+(range+field%3D%27priority%27+%7B49%2C101%7D))+${provided}+`;
      q += `(and+${field}%3A'${code}')`;
      // eslint-disable-next-line
      q += "(or+kind%3A'新築'+kind%3A'中古')";
      q += ')';
      q +=
        '&q.parser=structured&q.options=%7B%22defaultOperator%22%3A%22and%22%7D&return=_all_fields%2C_score';
      q += '&sort=provided_at+desc'; // 新着順は除外
      q += `&size=${limit}`;

      // 検索実行
      this.url = q;
      const r = await axios.get(q).then(res => res);
      return r.data.hits.hit;
    },
    async getKindPropertyList(limit, kind, prefCode, cityCode = 0) {
      let searchUrl;
      if (process.env.VUE_APP_ENV === 'prod') {
        searchUrl = 'https://l4goeq8bil.execute-api.ap-northeast-1.amazonaws.com/develop'; // 本番環境
      } else {
        searchUrl = 'https://y7dk5n6mq3.execute-api.ap-northeast-1.amazonaws.com/stg';// 開発環境
      }
      let field;
      let code;
      if (cityCode === 0) {
        field = 'pref_code';
        code = prefCode;
      } else {
        field = 'city_code';
        code = cityCode;
      }
      const p = new Date();
      p.setDate(p.getDate() - 15); // 14日以内
      const provided = `(and+(range+field%3Dprovided_at+%7B'${p.getFullYear()}-${p.getMonth() + 1}-${p.getDate()}T00%3A00%3A00Z'%2C%7D))`;
      let q = '';
      q = `${searchUrl}?q=(and+(and+(range+field%3D%27priority%27+%7B49%2C101%7D))+${provided}+`;
      q += `(and+${field}%3A'${code}')`;
      // eslint-disable-next-line
      if (kind === 1) {
        // eslint-disable-next-line
        q += "(or+kind%3A'新築')";
      } else if (kind === 2) {
        // eslint-disable-next-line
        q += "(or+kind%3A'中古')";
      } else {
        // eslint-disable-next-line
        q += "(or+kind%3A'新築'+kind%3A'中古')";
      }
      q += ')';
      q +=
        '&q.parser=structured&q.options=%7B%22defaultOperator%22%3A%22and%22%7D&return=_all_fields%2C_score';
      q += '&sort=provided_at+desc'; // 新着順は除外
      q += `&size=${limit}`;

      // 検索実行
      this.url = q;
      const r = await axios.get(q).then(res => res);
      return r.data.hits;
    },
    async getKindTownPropertyList(limit, kind, code) {
      let searchUrl;
      if (process.env.VUE_APP_ENV === 'prod') {
        searchUrl = 'https://l4goeq8bil.execute-api.ap-northeast-1.amazonaws.com/develop'; // 本番環境
      } else {
        searchUrl = 'https://y7dk5n6mq3.execute-api.ap-northeast-1.amazonaws.com/stg';// 開発環境
      }
      const p = new Date();
      p.setDate(p.getDate() - 15); // 14日以内
      const provided = `(and+(range+field%3Dprovided_at+%7B'${p.getFullYear()}-${p.getMonth() + 1}-${p.getDate()}T00%3A00%3A00Z'%2C%7D))`;
      let q = '';
      q = `${searchUrl}?q=(and+(and+(range+field%3D%27priority%27+%7B49%2C101%7D))+${provided}+`;
      q += `(and+town_code%3A'${code}')`;
      // eslint-disable-next-line
      if (kind === 1) {
        // eslint-disable-next-line
        q += "(or+kind%3A'新築')";
      } else if (kind === 2) {
        // eslint-disable-next-line
        q += "(or+kind%3A'中古')";
      } else {
        // eslint-disable-next-line
        q += "(or+kind%3A'新築'+kind%3A'中古')";
      }
      q += ')';
      q +=
        '&q.parser=structured&q.options=%7B%22defaultOperator%22%3A%22and%22%7D&return=_all_fields%2C_score';
      q += '&sort=provided_at+desc'; // 新着順は除外
      q += `&size=${limit}`;

      // 検索実行
      this.url = q;
      const r = await axios.get(q).then(res => res);
      return r.data.hits;
    },
    getCityAverage(cd, param) {
      return axios.get(ApiUrls.getCityAverageUrl(cd, param));
    },
  },
};
